import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from "prop-types";
import { Fieldset, Legend, styledSystemKeys } from "./viewbuttonFieldset.styles";
import { Flex, ViewButton } from "@base-ui";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ViewButtonFieldset = function ViewButtonFieldset(props) {
  var id = props.id,
    legend = props.legend,
    hideLabel = props.hideLabel,
    options = props.options,
    updateSelected = props.updateSelected,
    name = props.name,
    className = props.className;
  var viewButtons = options.map(function (option) {
    return /*#__PURE__*/_jsx(ViewButton, {
      id: "".concat(id, "-view-").concat(option.id),
      label: option.label,
      name: name,
      icon: option.icon,
      disabled: option.disabled,
      hideLabel: hideLabel,
      checked: option.checked,
      onChange: function onChange() {
        return updateSelected(option.id);
      }
    }, option.id);
  });
  return /*#__PURE__*/_jsxs(Fieldset, _objectSpread(_objectSpread({}, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    className: className,
    children: [/*#__PURE__*/_jsx(Legend, {
      children: legend
    }), /*#__PURE__*/_jsx(Flex.Row, {
      width: "inherit",
      children: viewButtons
    })]
  }));
};
ViewButtonFieldset.propTypes = {
  id: PropTypes.string.isRequired,
  legend: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  updateSelected: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  hideLabel: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object
};
export default ViewButtonFieldset;